import type { ApolloError } from 'apollo-client';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { expVal } from '@confluence/feature-experiments';

import { SpaceDetailQuery } from './SpaceDetailQuery.graphql';
import type { SpaceDetailQuery as SpaceDetailQueryType } from './__types__/SpaceDetailQuery';

export const preloadSpaceDetail = async (
	spaceKey: string | null | undefined = '',
): Promise<{
	data: SpaceDetailQueryType | null;
	loading?: boolean;
	error?: ApolloError | null;
}> => {
	if (spaceKey && !expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: SpaceDetailQuery,
			variables: {
				spaceKey,
			},
		});
	}

	return Promise.resolve({ data: null, loading: false, error: null });
};
